var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preloader", class: { "is-loaded": _vm.isLoaded } },
    [
      _c("div", { staticClass: "preloader__wrap" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.icons >= 2,
                expression: "icons >= 2"
              }
            ],
            staticClass: "preloader__logo-wrapper"
          },
          [
            _c("v-icon", {
              attrs: { name: "logo/loader" },
              on: { loaded: _vm.iconLoaded }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "icon-placeholder preloader__a" }),
            _vm._v(" "),
            _c(
              "div",
              { ref: "logo" },
              [
                _c("v-icon", {
                  staticClass: "preloader__a preloader__4 preloader__scale",
                  attrs: {
                    height: "71px",
                    name: "symbols/letters/a-blue",
                    width: "79px"
                  },
                  on: { loaded: _vm.iconLoaded }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "progress", staticClass: "preloader__progress" },
          [
            _c("v-typo", { attrs: { variant: "h4" } }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.progress.value.toFixed(0)) +
                  " %\n\t\t\t"
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }